import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { LoaderFacade } from '@redux/facades/loader.facade';
import { environment } from '../../../environments/environment';
import { NotificationFacade } from "@redux/facades/notification.facade";
import {AbstractClass, FormCell} from "@classes/abstract.class";
import {TranslatePipe} from "@pipes/translate/translate.pipe";

// Declare Vars
declare var $: any;

@Injectable({
  providedIn: 'root'
})
export class UtilsService {
  private isDebug = true;


  constructor(
    private router: Router,
    private translatePipe: TranslatePipe,
    private notificationFacade: NotificationFacade,
    private loaderFacade: LoaderFacade,
  ) { }

  public getUrl = (): string => {
    return environment.URL_API ?? '';
  }

  public getToken = (): string => {
    const session = sessionStorage.getItem('session');
    return session !== null ? JSON.parse(session).token : '';
  }

  public loadScript = (url: string) => {
    console.log('preparing to load... ' + url);
    const node = document.createElement('script');
    node.type = 'text/javascript';
    node.src = url;
    document.getElementsByTagName('head')[0].appendChild(node);
  }

  public debugConsole = (message: string) => {
    if (!environment.production) {
      console.log(message);
    }
  }

  public loader = (show: boolean = false) => {
    if (show) { this.loaderFacade.showLoader(); }
    else { this.loaderFacade.closeLoader(); }
  }

  public showMessageError = (message: string) => {
    this.notificationFacade.setError(message);
    alert(message);
  }

  public showError = (message: any, model:  AbstractClass | null = null) => {
    if (message.hasOwnProperty('success')) {
      this.debugConsole(message.error);
      this.showMessageError(message.error);
    } else {
      if (message.status === 401) {
        this.showMessageError('httpError.401');
        this.logout();
      } else if (message.status === 411) {
        this.showMessageError(message.error.msg);
      } else if (message.status === 400) {
        if (message.hasOwnProperty('error') && message.error !== null) {
          if (message.error.hasOwnProperty('error')) {
            // console.log('MESSAGE ERROR: ', message.error);
            const msgError = message.error.content ?? message.error.error ?? 'Error no definido';
            // console.log('msgError: ', msgError);
            this.showMessageError(msgError);
          } else {
            const errorList = message.error['errors'];
            let errorMsg = 'Hacen falta los siguientes datos: ';
            if (model !== null) {
              console.log(model);
              model.getInputsForm().map((item: FormCell) => {
                console.log(item, errorList);
                if (errorList.hasOwnProperty('$.' + item.name)) {
                  const name = this.translatePipe.transform(model?.langBase + item.label);
                  errorMsg = errorMsg + name + ',';
                }
              })
              this.showMessageError(errorMsg);
            } else {
              $('body').append('<div class="errorDiv"><table id="tableErrors"></table></div>');
              $('.errorDiv').click(() => { $('.errorDiv').remove(); });
              // tslint:disable-next-line:forin
              for (const err in errorList) {
                const test = errorList[err][0];
                const varError = test.indexOf('value {null}') === -1 ? errorList[err] : 'not null';
                $('#tableErrors').append('<tr><td><b class="tableErrWhite">' + err + '</b>' + varError + '</td></tr>');
              }
            }
          }
        } else {
          this.showMessageError(message.message);
        }
      } else if (message.status === 404) {
        this.debugConsole(message);
        if (message.error === null) {
          this.showMessageError('httpError.404');
        } else {
          this.showMessageError(message.error.error);
        }
      } else if (message.status === 503 || message.status === 500 || message.status === 0) {
        // $('body').append('<div class="errorDiv"><table id="tableErrors"></table></div>');
        // $('.errorDiv').click(() => { $('.errorDiv').remove(); });
        // $('#tableErrors').append('<tr><td>' + message.error.msg + '</td></tr>');
        // this.alert(message.error.message);
        alert('Error (500-503), Hemos detectado un problema de conexión por favor intenta mas tarde!');
      } else if (this.isDebug) {
        this.debugConsole(message);
        this.showMessageError(message.message);
      } else {
        this.showMessageError('Error no identificado');
      }
    }
  }

  public logout = () => {
    sessionStorage.clear();
    this.router.navigate(['/login']);
  }
}
